import React, { useState, useCallback } from 'react';

import { PopUp, Dialog } from '@ergeon/core-components';
import { TrashIcon } from '@ergeon/icons/hero/micro';

type DeleteThreadDialogProps = {
  isVisible: boolean;
  threadPreview: string;
  onClose: () => void;
  onConfirm: () => Promise<void>;
};

const DeleteThreadDialog: React.FC<DeleteThreadDialogProps> = ({
  isVisible,
  threadPreview,
  onClose,
  onConfirm,
}) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleClose = useCallback(() => {
    if (!isDeleting) {
      onClose();
    }
  }, [isDeleting, onClose]);

  const handleConfirm = useCallback(async() => {
    setIsDeleting(true);
    try {
      await onConfirm();
    } finally {
      setIsDeleting(false);
    }
  }, [onConfirm]);

  return (
    <PopUp isVisible={isVisible} maxWidth="small" onChangeVisible={handleClose}>
      <Dialog
        cancelButtonText="Cancel"
        icon={<TrashIcon className="size-5 text-red-500" />}
        isLoading={isDeleting}
        isVisible={isVisible}
        onDismiss={handleClose}
        onSubmit={handleConfirm}
        showButtons
        submitButtonFlavor="danger"
        submitButtonText={isDeleting ? 'Deleting...' : 'Delete'}
        title="Delete Conversation">
        <div className="flex flex-col gap-2">
          <p className="text-gray-700 dark:text-gray-300 paragraph-2">
            Are you sure you want to delete this conversation?
          </p>
          <p className="font-bold text-gray-900 dark:text-white truncate paragraph-2">
            "{threadPreview || 'New conversation'}"
          </p>
          <p className="text-gray-500 dark:text-gray-400 paragraph-3">
            * This action cannot be undone.
          </p>
        </div>
      </Dialog>
    </PopUp>
  );
};

export default DeleteThreadDialog;
